import * as kissbotEventTypes from "./kissbot-event-data-types";

export * from "./kissbot-event-data-types";

export enum KissbotEventType {
    // ================CONVERSATION MANAGER EVENTS======================

    // Quando uma conversa é criada no conversation manager
    CONVERSATION_CREATED = 'conversation.created',

    // Quando uma conversa é criada no conversation manager
    CONVERSATION_UPDATED = 'conversation.updated',

    CONVERSATION_UPDATED_REQUEST = 'conversation.updated.request',

    // Quando uma conversa é criada no conversation manager
    CONVERSATION_STARTED = 'conversation.started',

    // Quando uma conversa é finalizada
    CONVERSATION_CLOSED = 'conversation.closed',

    // Quando uma conversa é finalizada
    CONVERSATION_SUSPENDED = 'conversation.suspended',

    // Quanto uma conversa é redirecionada do bot para outro canal
    CONVERSATION_REDIRECT_REQUEST = 'conversation.redirect.request',

    // Quanto uma conversa é assinada para um time ou para um membro de um time
    CONVERSATION_ASSIGNED = 'conversation.assigned',

    // Quando uma conversa é desabilitada para um time ou para um membro de um time
    CONVERSATION_UNASSIGNED = 'conversation.unassigned',

    // Quando alguem quer que uma conversa seja assinada para um time ou para um membro de um time
    CONVERSATION_ASSIGN_REQUEST = 'conversation.assign.request',

    // Quando alguem quer que uma conversa seja desabilitada para um time ou para um membro de um time
    CONVERSATION_UNASSIGN_REQUEST = 'conversation.unassign.request',

    // Quando uma conversa é atualizada com o parametro redirected setado
    CONVERSATION_REDIRECTED = 'conversation.redirected',

    // Quando é feito do "desredirecionamento" da conversa
    CONVERSATION_UNREDIRECTED = 'conversation.unredirected',

    //
    CONVERSATION_CONTEXT_CHANGED = 'conversation.context.changed',

    // Quando um membro é adicionado á conversa
    CONVERSATION_MEMBER_ADDED = 'conversation.member.added',

    CONVERSATION_MEMBER_ADDED_REQUEST = 'conversation.member.added.request',

    CONVERSATION_MEMBER_UPDATED = 'conversation.member.updated',
    
    CONVERSATION_MEMBERS_UPDATED = 'conversation.members.updated',

    CONVERSATION_MEMBER_UPDATED_REQUEST = 'conversation.member.updated.request',
    
    CONVERSATION_MEMBER_CONTACT_ID_UPDATE_REQUEST = 'conversation.member.contact-id.updated.request',

    // Quando um membro é adicionado á conversa
    CONVERSATION_MEMBER_REMOVED = 'conversation.member.removed',

    // Quando um membro faz upload ed um arquivo(attachment) na conversa
    CONVERSATION_MEMBER_UPLOAD_ATTACHMENT = 'conversation.member.upload.attachment',

    // Quando as tags de uma conversa devem ser alteradas.

    CONVERSATION_METRICS_UPDATED = 'conversation.metrics.updated',
    CONVERSATION_TAGS_UPDATE = 'conversation.tags.update',

    CONVERSATION_TAGS_UPDATE_REQUEST = 'conversation.tags.update.request',

    ONVERSATION_TAGS_DELETE = 'conversation.tags.delete',

    CONVERSATION_TAGS_DELETE_REQUEST = 'conversation.tags.delete.request',

    CONVERSATION_VIEWED_REQUEST = 'conversation.viewed.request',

    CONVERSATION_ADD_ATTRIBUTE_REQUEST = 'conversation.add.attribute.request',
    CONVERSATION_REMOVE_ATTRIBUTE_REQUEST = 'conversation.remove.attribute.request',

    CONVERSATION_ATTRIBUTE_ADDED = 'conversation.attribute.added',
    CONVERSATION_ATTRIBUTE_REMOVED = 'conversation.attribute.removed',
    CONVERSATION_WHATSAPP_EXPIRATION_UPDATED = 'conversation.whatsapp_expiration.updated',
    
    CAMPAIGN_EVENT = 'campaign.event',

    ACTIVE_MESSAGE_RESPONSE = 'active-message-response',
    
    SEND_MESSAGE = 'send.message',

    ACTIVITY_LAST_MESSAGE = 'activity.last.message',

    // Quando a activity é recebida pelo conversation manager
    ACTIVITY_RECEIVED = 'activity.received',

    ACTIVITY_RECEIVED_REQUEST = 'activity.received.request',

    // Quando a activity é recebida pelo conversation manager
    ACTIVITY_SENDED = 'activity.sended',

    ACK_TO_PROCESS = 'ack.to.process',

    // Quando a activity chega no canal. Cada canal deve enviar o evento para o socket poder capturá-lo
    ACTIVITY_DELIVERED = 'activity.delivered',
    ACTIVITY_HASH_UPDATED = 'activity.hash.updated',

    // Emitido pelo conversation manager com um array de activities
    ACTIVITY_SYNC = 'activity.sync',

    //Emitido pelo wrapper para verificar se um activity com mesmo hash existe
    ACTIVITY_CHECK_EXISTS = 'activity.check_exists',

    ACTIVITY_INDEX_REQUEST = 'activity.index.request',

    ACTIVITY_ACK_AND_HASH_UPDATED = 'activity.ack.hash.updated',

    // ================ENGINE EVENTS==================
    // Quando a interaction que foi reconhecida é enviada para o conversation manager

    // ================API EVENTS==================
    // Quando um novo usuário é criado na plataforma
    USER_CREATED = 'user.created',
    // Quando um usuário da plataforma é atualizado
    USER_UPDATED = 'user.updated',
    // Quando um agente de transbordo é criado
    USER_DELETED = 'user.deleted',

    // Quando um novo channelconfig é criado na plataforma
    CHANNEL_CONFIG_CREATED = 'channel-config.created',
    // Quando um channelconfig da plataforma é atualizado
    CHANNEL_CONFIG_UPDATED = 'channel-config.updated',
    // Quando um channelconfig de transbordo é criado
    CHANNEL_CONFIG_DELETED = 'channel-config.deleted',
    // Quando um channel config do tipo whatsweb é criado
    CHANNEL_CONFIG_WHATSWEB_CREATED = 'channel-config.whatsweb.created',
    // Quando um channel config do tipo whatsweb é atualizado
    CHANNEL_CONFIG_WHATSWEB_UPDATED = 'channel-config.whatsweb.updated',

    // Quando um novo usuário é criado na plataforma
    AGENT_CREATED = 'agent.created',
    // Quando um agent é atualizado de transbordo é atualizado
    AGENT_UPDATED = 'agent.updated',
    // Quando um agente de transboro é deletado
    AGENT_DELETED = 'agent.deleted',

    // Quando um workspace é criado dentro da api
    WORKSPACE_CREATED = 'workspace.created',
    // Quando um workspace é atualizado dentro da api
    WORKSPACE_UPDATED = 'workspace.updated',
    // Quando um workspace é deletado dentro da api
    WORKSPACE_DELETED = 'workspace.deleted',
    WORKSPACE_DISABLED = 'workspace.disabled',


    // Alterações realizadas nos times
    // Quando um workspace é criado dentro da api
    TEAM_CREATED = 'team.created',
    // Quando um workspace é atualizado dentro da api
    TEAM_UPDATED = 'team.updated',
    // Quando um workspace é deletado dentro da api
    TEAM_DELETED = 'team.deleted',
    

    // Quando um bot é criado dentro da api
    BOT_CREATED = 'bot.created',
    // Quando um bot é atualizado dentro da api
    BOT_UPDATED = 'bot.updated',
    
    BOT_PUBLISHED = 'bot.published',

    // Quando um bot é deletado dentro da api
    BOT_DELETED = 'bot.deleted',

    // Quando um bot é criado dentro da api
    CONTACT_CREATED = 'contact.created',
    // Quando um bot é atualizado dentro da api
    CONTACT_UPDATED = 'contact.updated',
    // Quando um bot é deletado dentro da api
    CONTACT_DELETED = 'contact.deleted',
    //
    CONTACT_BLOCKED = 'contact.blocked',

    // Quando uma interaction é criada dentro da api
    INTERACTION_CREATED = 'interaction.created',
    // Quando uma interaction é atualizada dentro da api
    INTERACTION_UPDATED = 'interaction.updated',
    // Quando uma interaction é deletada dentro da api
    INTERACTION_DELETED = 'interaction.deleted',
    //
    INTERACTION_RECOGNIZED = 'interaction.recognized',
    
    INTERACTION_FALLBACK_RECOGNIZED = 'interaction.fallback.recognized',

    ANALYTICS_INDEX_CONVERSATION_REQUEST = 'analytics.index.conversation.request',
    ANALYTICS_REINDEX_CONVERSATION_REQUEST = 'analytics.reindex.conversation.request',
    ANALYTICS_INDEX_ACTIVITY_REQUEST = 'analytics.index.activity.request',
    ANALYTICS_REINDEX_ACTIVITY_REQUEST = 'analytics.reindex.activity.request',

    SOCKET_SEND_REQUEST = 'socket.send.request',

    // ================WHATSAPP PY_EXTENSION EVENTS==================
    WHATSWEB_QRCODE_REQUEST = 'whatsweb.qrcode.request',
    WHATSWEB_QRCODE_RESPONSE = 'whatsweb.qrcode.response',
    WHATSWEB_SCREENSHOT_REQUEST = 'whatsweb.screenshot.request',
    WHATSWEB_SCREENSHOT_RESPONSE = 'whatsweb.screenshot.response',
    WHATSWEB_DRIVER_STATUS_REQUEST = 'whatsweb.driver_status.request',
    WHATSWEB_DRIVER_STATUS_RESPONSE = 'whatsweb.driver_status.response',
    WHATSWEB_SYNC_CONTACTS_REQUEST = 'whatsweb.sync_contacts.request',
    WHATSWEB_SYNC_CONTACTS_RESPONSE = 'whatsweb.sync_contacts.response',
    WHATSWEB_SYNC_CHAT_REQUEST = 'whatsweb.sync_chat.request',
    WHATSWEB_SYNC_CHAT_RESPONSE = 'whatsweb.sync_chat.response',
    WHATSWEB_LOGGEDIN_RESPONSE = 'whatsweb.loggedin.response',
    WHATSWEB_USE_HERE_REQUEST = 'whatsweb.use_here.request',
    WHATSWEB_CHECK_PHONE_NUMBER_REQUEST = 'whatsweb.check_phone_number.request',
    WHATSWEB_CHECK_PHONE_NUMBER_RESPONSE = 'whatsweb.check_phone_number.response',
    WHATSWEB_IMPORT_CONTACTS_REQUEST = 'whatsweb.import_contacts.request',
    WHATSWEB_IMPORT_CONTACTS_RESPONSE = 'whatsweb.import_contacts.response',
    WHATSWEB_MESSAGE_ACK = 'whatsweb.message.ack',
    WHATSWEB_MESSAGE_ACK_ERROR = 'whatsweb.message.ack.error',
    WHATSWEB_MESSAGE_EXISTS = 'whatsweb.message.exists',
    WHATSWEB_IMPORT_MESSAGES_REQUEST = 'whatsweb.import_messages.request',

    //=============================gupshup events=================================
    GUPSHUP_MESSAGE_DELIVERED = 'gupshup.message.delivered',
    GUPSHUP_ACK_DELIVERED = 'gupshup.ack.delivered',
    GUPSHUP_NUMBER_DONT_EXISTS_RECEIVED = 'gupshup.number_dont_exists.received',

    INTEGRATION_HEALTH_APPOINTMENT_SCHEDULED = 'integration.health.appointment.sheduled',

    INTEGRATION_HEALTH_APPOINTMENT_CONFIRMED = 'integration.health.appointment.confirmed',
    INTEGRATION_HEALTH_APPOINTMENT_CANCELED = 'integration.health.appointment.canceled',

    INTEGRATION_HEALTH_SCHEDULING_WITHOUT_AVAILABILITY = "integration.health.appointment.without-availability",

    INTEGRATION_HEALTH_SCHEDULING_WITHOUT_ENTITIES = "integration.health.appointment.without-entities",

    INTEGRATION_HEALTH_SCHEDULING_AVAILABILITY = "integration.health.appointment.availability",

    INTEGRATION_HEALTH_SCHEDULING_REDIRECTED = "integration.health.appointment.redirected",

    INTEGRATION_HEALTH_APPOINTMENT_STEP = "integration.health.appointment.step",

    INTEGRATION_HEALTH_REASON_FOR_NOT_SCHEDULING_CREATED = "integration.health.reason-for-not-scheduling.created",
    
    CONVERSATION_WHATSAPP_SESSION_COUNT_INCREMENT = "conversation.whatsapp-session-count.increment",

    INTEGRATION_HEALTH_CREATE_AUDIT = "integration.health.create-audit",

    // ====
    LOG_CREATED = 'log.created',
    LOG_RETRY = 'log.retry',

    // ==== active message
    ACTIVE_MESSAGE_STATUS_CHANGED = 'active-message-status.changed',
    ACTIVE_MESSAGE_USER_RECEIVED = 'active-message.user.received',
    ACTIVE_MESSAGE_USER_READ = 'active-message.user.read',
    ACTIVE_MESSAGE_USER_ANSWERED = 'active-message.user.answered',

    //=============================email events=================================
    EMAIL_CREATED = `email.created`,
    EMAIL_SENT = `email.sent`,
    EMAIL_PROCESSED = 'email.processed', // Message has been received and is ready to be delivered.
    EMAIL_DROPPED = 'email.dropped', // You may see the following drop reasons: Invalid SMTPAPI header, Spam Content (if Spam Checker app is enabled), Unsubscribed Address, Bounced Address, Spam Reporting Address, Invalid, Recipient List over Package Quota
    EMAIL_DELIVERED = 'email.delivered', // Message has been successfully delivered to the receiving server
    EMAIL_DEFERRED = 'email.deferred', // Receiving server temporarily rejected the message.
    EMAIL_BOUNCE = 'email.bounce', // Receiving server could not or would not accept mail to this recipient permanently. If a recipient has previously unsubscribed from your emails, the message is dropped
    EMAIL_OPENED = `email.opened`,
    EMAIL_CLICK = 'email.click',

    //==================================================Billing events===========
    BILLING_CREATED_PAYMENT = 'billing.created.payment',


    //==================================================Rating events===========
    RATING_RECEIVED = 'rating.received',

    //==================================================scheduling events===========
    // Quando é confirmado pelo scheduling no integrations
    SCHEDULING_CONFIRMATION_CONFIRMED = 'scheduling.confirmation.confirmed',
    // Quando é cancelado pelo scheduling no integrations
    SCHEDULING_CONFIRMATION_CANCELED = 'scheduling.confirmation.canceled',

    //==================================================schedule events============
    // Quando é cancelado no engine e seleciona o motivo do cancelamento
    SCHEDULE_CONFIRMATION_CANCEL_REASON = 'schedule.confirmation.cancel_reason',
}

export type KissbotEventData =
    kissbotEventTypes.IConversationContextChangedEvent |
    kissbotEventTypes.IConversationUpdatedEvent |
    kissbotEventTypes.IConversationCreatedEvent |
    kissbotEventTypes.IConversationWhatsappExpirationUpdated |
    kissbotEventTypes.IConversationEndedEvent |
    kissbotEventTypes.IConversationSuspendedEvent |
    kissbotEventTypes.IConversationAddAttributeRequestEvent |
    kissbotEventTypes.IConversationRemoveAttributeRequestEvent |
    kissbotEventTypes.IConversationMemberAddedEvent |
    kissbotEventTypes.IConversationMemberRemovedEvent |
    kissbotEventTypes.IConversationMemberUpdatedEvent |
    kissbotEventTypes.IConversationRedirectedEvent |
    kissbotEventTypes.IConversationStartedEvent |
    kissbotEventTypes.IConversationUnredirectedEvent |
    kissbotEventTypes.IConversationMemberUploadAttachment |
    kissbotEventTypes.IConversationAssignRequestEvent |
    kissbotEventTypes.IConversationAssignEvent |
    kissbotEventTypes.IConversationMetricsUpdatedEvent |
    kissbotEventTypes.IConversationAddAttributeEvent | 
    kissbotEventTypes.IConversationRemoveAttributeEvent | 

    kissbotEventTypes.IActivityLastMessage |
    kissbotEventTypes.IActivityIndexRequestEvent |
    kissbotEventTypes.IActivityReceivedEvent |
    kissbotEventTypes.IActivitySendedEvent |
    kissbotEventTypes.IActivitySyncEvent |
    kissbotEventTypes.IActivityHashUpdatedEvent |

    kissbotEventTypes.IAckToProcess |

    kissbotEventTypes.IUserCreatedEvent |
    kissbotEventTypes.IUserDeletedEvent |
    kissbotEventTypes.IUserUpdatedEvent |

    kissbotEventTypes.IChannelConfigCreatedEvent |
    kissbotEventTypes.IChannelConfigDeletedEvent |
    kissbotEventTypes.IChannelConfigUpdatedEvent |
    kissbotEventTypes.IChannelConfigWhatswebUpdatedEvent |
    kissbotEventTypes.IChannelConfigWhatswebCreatedEvent |

    kissbotEventTypes.IAgentCreatedEvent |
    kissbotEventTypes.IAgentDeletedEvent |
    kissbotEventTypes.IAgentUpdatedEvent |

    kissbotEventTypes.IWorkspaceCreatedEvent |
    kissbotEventTypes.IWorkspaceDeletedEvent |
    kissbotEventTypes.IWorkspaceUpdatedEvent |

    kissbotEventTypes.IBotCreatedEvent |
    kissbotEventTypes.IBotUpdatedEvent |
    kissbotEventTypes.IBotDeletedEvent |
    kissbotEventTypes.IBotPublishedEvent |

    kissbotEventTypes.IContactCreatedEvent |
    kissbotEventTypes.IContactDeletedEvent |
    kissbotEventTypes.IContactUpdatedEvent |

    kissbotEventTypes.IInteractionCreatedEvent |
    kissbotEventTypes.IInteractionDeletedEvent |
    kissbotEventTypes.IInteractionRecognizedEvent |
    kissbotEventTypes.IInteractionUpdatedEvent |

    kissbotEventTypes.ISocketSendRequestEvent |

    kissbotEventTypes.IWhatswebDriverStatusRequestEvent |
    kissbotEventTypes.IWhatswebDriverStatusResponseEvent |
    kissbotEventTypes.IWhatswebQrCodeRequestEvent |
    kissbotEventTypes.IWhatswebQrCodeResponseEvent |
    kissbotEventTypes.IWhatswebScreenshotRequestEvent |
    kissbotEventTypes.IWhatswebScreenshotResponseEvent |
    kissbotEventTypes.IWhatswebSyncChatRequestEvent |
    kissbotEventTypes.IWhatswebSyncChatResponseEvent |
    kissbotEventTypes.IWhatswebSyncContactRequestEvent |
    kissbotEventTypes.IWhatswebSyncContactResponseEvent |
    kissbotEventTypes.IWhatswebUseHereRequestEvent |
    kissbotEventTypes.IWhatswebCheckPhoneNumberResponseEvent |
    kissbotEventTypes.IWhatswebCheckPhoneNumberRequestEvent |
    kissbotEventTypes.IWhatswebMessageAck |
    kissbotEventTypes.IWhatswebMessageActivityExists |
    kissbotEventTypes.IWhatswebImportMessagesRequestEvent |
    kissbotEventTypes.IWhatsAppSessionCountIncrementEvent |

    /** Logs */
    kissbotEventTypes.ILogCreated |

    /** HEALTH */
    kissbotEventTypes.IAppointmentSheduledEvent |
    kissbotEventTypes.IGupshupMessageDeliveredEvent |
    kissbotEventTypes.IGupshupNumberDontExistsReceivedEvent |
    kissbotEventTypes.IAppointmentStepData |
    kissbotEventTypes.IReasonForNotSchedulingData |
    
    /** BILLING */
    kissbotEventTypes.IBillingCreatedPaymentEvent |

    /** RATING */
    kissbotEventTypes.IRatingReceivedEvent;

export enum KissbotEventDataType {
    TAGS = 'tags',
    ACTIVITY = 'activity',
    ACTIVITY_ARRAY = 'activityArray',
    INTERACTION = 'interaction',
    CONVERSATION = 'conversation',
    CONVERSATION_ATTRIBUTE = 'conversationAttribute',
    CHANNEL_CONFIG = 'channelConfig',
    MEMBER = 'member',
    RECOGNIZER_RESULT = 'recognizerResult',
    USER = 'user',
    AGENT = 'agent',
    WORKSPACE = 'workspace',
    BOT = 'bot',
    CONTACT = 'contact',
    ATTACHMENT = 'attachment',
    WHATSAPP_QR_CODE = 'whatsappQrCode',
    CONVERSATION_REDIRECT_REQUEST = 'conversation.redirect.request',
    WHATSAPP_LOGGEDIN_RESPONSE = 'whatsweb.loggedin.response',
    WHATSWEB_DRIVER_STATUS_RESPONSE = 'whatsweb.driver_status.response',
    WHATSWEB_CHECK_PHONE_NUMBER_REQUEST = 'whatsweb.check_phone_number.request',
    WHATSWEB_CHECK_PHONE_NUMBER_RESPONSE = 'whatsweb.check_phone_number.response',
    WHATSWEB_MESSAGE_ACK = 'whatsweb.message.ack',
    CONVERSATION_WHATSAPP_EXPIRATION_UPDATED = 'conversation.whatsapp_expiration.updated',
    ACTIVITY_HASH_UPDATED = 'activity.hash.updated',
    ACTIVITY_DELIVERED = 'activity.delivered',
    SOCKET = 'socket',
    METRICS = 'metrics',
    CONVERSATION_ASSIGN = 'conversation.assign',
    ANY = 'any',
    LOG = 'log',

    APPOINTMENT_STEP_DATA = 'integration.health.appointment.step-data',
    APPOINTMENT_SCHEDULED = 'integration.health.appointment.sheduled',
    APPOINTMENT_CONFIRMED = 'integration.health.appointment.confirmed',
    APPOINTMENT_CANCELED = 'integration.health.appointment.canceled',
}

export enum KissbotEventSource {
    ENGINE = 'engine',
    LAMBDA = 'LAMBDA',
    CONVERSATION_MANAGER = 'conversation-manager',
    KISSBOT_API = 'kissbot-api',
    WHATSAPP_EXT = 'whatsapp-ext',
    KISSBOT_INTEGRATIONS = 'kissbot-integrations'
}

export interface KissbotEventError {
    code: number;
    message: string;
    stack: string;
}
export interface KissbotEvent {
    source: KissbotEventSource;
    type: KissbotEventType;
    dataType: KissbotEventDataType;
    data: KissbotEventData | null | undefined;
    error?: KissbotEventError;
    id?: string;
    timestamp?: string;
}

export enum KissbotEventFailureType {
    FAILURE = 'failure',
}